import { render, staticRenderFns } from "./refuntablelist.vue?vue&type=template&id=6724e053&scoped=true&"
import script from "./refuntablelist.vue?vue&type=script&lang=js&"
export * from "./refuntablelist.vue?vue&type=script&lang=js&"
import style0 from "./refuntablelist.vue?vue&type=style&index=0&id=6724e053&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6724e053",
  null
  
)

export default component.exports